import React from 'react';

import styles  from "./DataDisplay.module.css";

const DataDisplay = (props) => {
  console.log( props )
  
  let patRelation;
  switch (props.data?.pat_relation) {
    case "0": patRelation = "Unterzeichner/in ist selbst Patient/in"; break;
    case "1": patRelation = "Unterzeichner/in ist Elternteil"; break;
    case "2": patRelation = "Unterzeichner/in ist Sorgerechtige/r"; break;
    default: patRelation = ""; break;
  }

  return <>
    <div className={styles.DataDisplay}>
      <div className={styles.DataBlock}>
        { props.qrcode &&
          <div>
            Befund ausgestellt am {props.qrcode?.created}<br />
            von {props.qrcode?.createdBy}<br />
          </div>
        } 
        { props.hasImage &&
          <div>
            Bild vom QR Code:<br />
            <img src={props.hasImage} width="100px" />
          </div>
        }
        <br />
        Patient Name: {props.data?.pat_name}<br />
        Patient Vorname: {props.data?.pat_first_name}<br />
        { patRelation }<br />
        Titel: {props.data?.ref}<br />
        <br/>
        Unterzeichnet<br />
        {props.data?.sig_place}, {props.data?.sig_date}<br />
        {props.data?.sig_first_name} {props.data?.sig_name}<br />
      </div>
      <div className={styles.DataBlock}>
        Kontaktierung:<br />
        - für Behandlungsmöglichkeiten: {!props.data?.accept_therapy.includes('false') ? 'Ja' : 'Nein'}<br />
        - bei neuen wissenschaftlichen Erkenntnissen: {!props.data?.accept_reevaluation.includes('false') ? 'Ja' : 'Nein'}<br />
        - von diagnosespezifischen Patientenregistern: {!props.data?.accept_registers.includes('false') ? 'Ja' : 'Nein'}<br />
        - von Patientenorganisationen: {!props.data?.accept_organizations.includes('false') ? 'Ja' : 'Nein'}<br />
        - von anderen Patienten: {!props.data?.accept_patients.includes('false') ? 'Ja' : 'Nein'}<br />
      </div>
    </div>
  </>  
}

export default DataDisplay;

// - für klinische Studien: {props.data?.accept_studies.includes('true') ? 'Ja' : 'Nein'}<br />